<template>
  <div class="advantage-title" v-if="title">
    {{ title }}
  </div>
</template>

<script>
  export default {
    name: 'advantage-title',

    props: ['title']
  }
</script>

<style lang="scss" scoped>
  .advantage-title {
    padding-top: 24px;
    padding-bottom: 16px;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: #20283e;
  }
</style>
